// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productCardContainer {
  position: relative;
  width: 100%;
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  box-shadow: none;
}

.cardContainer:hover {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.addContainer {
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
}

.addBox {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.5rem !important;
  background-color: #005B96 !important;
}

.offContainer {
  width: fit-content;
  background-color: #CC0056;
  border-radius: 0.4rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unit {
  font-size: 0.6rem;
}

.priceContainer {
  font-size: 0.7rem;
  text-decoration: line-through;
  line-height: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/ProductCard/product.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;AACF;;AAGA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,6BAAA;EACA,mBAAA;AAAF","sourcesContent":[".productCardContainer {\n  position: relative;\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.5rem;\n  box-shadow: none;\n}\n\n.cardContainer:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n\n.addContainer {\n  position: absolute;\n  left: 0.5rem;\n  top: 0.5rem;\n}\n\n.addBox {\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 0.5rem !important;\n  background-color: #005B96 !important;\n}\n\n\n.offContainer {\n  width: fit-content;\n  background-color: #CC0056;\n  border-radius: 0.4rem;\n  padding: 0 0.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.unit {\n  font-size: 0.6rem;\n}\n\n.priceContainer {\n  font-size: 0.7rem;\n  text-decoration: line-through;\n  line-height: 0.8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
